import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { RoleDataPayload, RoleDataResponse } from "@/types/interface/role";

async function createRole(payload: RoleDataPayload) {
  return await http.post<APIResponse<RoleDataResponse>>("role/create", payload);
}

async function updateRole(idRole = '', payload: RoleDataPayload) {
  return await http.patch<APIResponse<RoleDataResponse>>(`role/update?id=${idRole}`, payload);
}

async function getRole(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<RoleDataResponse>>(`role?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findRole(idRole = "") {
  return await http.get<APIResponse<RoleDataResponse>>(`role/detail?id=${idRole}`);
}

async function deleteRole(idRole = "") {
  return await http.delete<APIResponse<RoleDataResponse>>(`role/delete?id=${idRole}`);
}

export default {
  createRole,
  updateRole,
  getRole,
  findRole,
  deleteRole
};